function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { EXO_SKELETON_EVENT_NAMES } from './consts';
import { createPostMessageEventHandler, hasExoSkeletonListenerInitialized, sendRuntimeDataEvent } from './runtime';
export const MONITORING_HOST_REPORT_EVENT_NAME = EXO_SKELETON_EVENT_NAMES.MONITORING_HOST_REPORT_EVENT_NAME;
export const REPORT_TYPES = {
  info: 'info',
  warning: 'warning',
  error: 'error'
};
export function isMonitoringReportDataEvent(data) {
  return (data === null || data === void 0 ? void 0 : data.type) === MONITORING_HOST_REPORT_EVENT_NAME;
}

/**
 * Used to create a listener for the ExoSkeleton monitoring.
 */
export function createMonitoringListener(_ref) {
  let {
    onReport
  } = _ref;
  return createPostMessageEventHandler(MONITORING_HOST_REPORT_EVENT_NAME, function (_ref2) {
    let {
      data
    } = _ref2;
    if (isMonitoringReportDataEvent(data)) {
      onReport(data);
    }
  });
}
export function report(data) {
  if (!hasExoSkeletonListenerInitialized(MONITORING_HOST_REPORT_EVENT_NAME)) {
    console.warn('"report" was called, but the ExoSkeleton host did not initialize the "createMonitoringListener". Data sent:', data);
  }
  if (!data.scope) {
    console.warn('"report" should be called with a scope, please add your ExoSkeleton name, e.g. "accDemoApp"');
  } else {
    data.context = {
      scope: data.scope,
      [data.scope]: data.context
    };
  }
  if (data.UNSAFE__globalContext) {
    data.context = _objectSpread(_objectSpread({}, data.context), data.UNSAFE__globalContext);
    delete data.UNSAFE__globalContext;
  }
  if (!Object.values(REPORT_TYPES).includes(data.type)) {
    throw new Error("Cannot execute \"report\" with an invalid type: \"".concat(data.type, "\". Please use one of: ").concat(Object.values(REPORT_TYPES).toString()));
  }
  return sendRuntimeDataEvent(MONITORING_HOST_REPORT_EVENT_NAME, data);
}
//# sourceMappingURL=monitoring.js.map